export default {"src":"/_next/static/media/opening-terminal.5b008287.gif","height":700,"width":1309,"blurWidth":0,"blurHeight":0};